import axios from 'axios';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import SmartStore from './template/SmartStore';
import Street from './template/Street';
import Coupang from './template/Coupang';
import { allowScroll, preventScroll } from '../../common/utils';

export default function MarketTemplateSlideModal() {
	const [TabList, setTabList] = useState([]);
	const [ActiveIndex, setActiveIndex] = useState(null);
	const [TableIndex, setTableIndex] = useState(null);

	const handleActiveIndex = (index) => {
		if (ActiveIndex !== index) {
			/* eslint-disable no-restricted-globals */
			const isOk = confirm(`탭 변경 시 작성된 내용이 사라집니다. 변경하시겠습니까?`);
			/* eslint-enable no-restricted-globals */
			if (isOk) {
				setActiveIndex(index);
			}
		}
	};

	useEffect(() => {
		//탭리스트 요청API
		// axios
		// 	.post(`${window.location.protocol}//${window.location.hostname}:3001/`,	qs.stringify({
		// 	token: localStorage.getItem('token')
		// })
		// )
		// 	.then((res) => {
		// 		setTabList([])
		// 	})
		// 	.catch();
		setTabList([
			{ idx: 0, name: '스마트 스토어' },
			{ idx: 1, name: '11번가' },
			{ idx: 2, name: '쿠팡' },
		]);
		setActiveIndex(0);

		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY);
		};
	}, []);
	useEffect(() => {
		const newIndex = ActiveIndex;
		setTableIndex(newIndex);
	}, [ActiveIndex]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1, transition: { duration: 0.2 } }}
			exit={{ opacity: 0, transition: { delay: 0.1, duration: 0.1 } }}
			className='marketRegistrationModal'
		>
			<motion.div initial={{ x: 100 }} animate={{ x: 0, transition: { duration: 0.3 } }} exit={{ x: 100, transition: { duration: 0.2 } }}>
				<div className='slide-modal-content'>
					<ul className='tabs'>
						{TabList.map((el, index) => {
							return (
								<li key={el.idx} className={el.idx === ActiveIndex ? 'active' : ''} onClick={() => handleActiveIndex(index)}>
									{el.name}
								</li>
							);
						})}
					</ul>
					<div className='tables'>
						{TableIndex === 0 && <SmartStore />}
						{TableIndex === 1 && <Street />}
						{TableIndex === 2 && <Coupang />}
					</div>
					<div className='updateButton'>
						<button disabled={true}>수정</button>
					</div>
				</div>
			</motion.div>
		</motion.div>
	);
}
